import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchMarketingCampaignsRequest,
  fetchMarketingCampaignsSuccess,
  fetchMarketingCampaignsFailure,
} from '../slices/marketingCampaignSlice';
import type { ScheduledCampaign } from '../../components/marketingCampaign/types';

function* fetchMarketingCampaignsSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${ENDPOINTS.schedule_campaign}/${restaurantId}`;
    const response = yield call(axios.get, url);

    // Handle response - it might be wrapped in data or be a direct array
    const campaigns: ScheduledCampaign[] = Array.isArray(response.data) 
      ? response.data 
      : (response.data?.data || []);
    
    yield put(fetchMarketingCampaignsSuccess(campaigns));
  } catch (error: any) {
    yield put(
      fetchMarketingCampaignsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch marketing campaigns'
      )
    );
  }
}

export function* marketingCampaignSaga() {
  yield takeLatest(fetchMarketingCampaignsRequest.type, fetchMarketingCampaignsSaga);
}
